// extracted by mini-css-extract-plugin
export default {"amenityTextSmall":"styles-module--amenityTextSmall--usDpe","amenityText":"styles-module--amenityText--obalz"};